import Tabs from "./Tabs";
import Items from "./Items";
import Data from "./PortfolioData";
import { useState } from "react";
import { Link } from "react-router-dom";

function FacebookGallery() {
    const [data, setData] = useState(Data);
    const categoryData = Data.map((value)=>{
          return value.category
     });
    const tabsData= ["all", ...new Set(categoryData)];
    
    const filterCategory=(category) =>{
        if(category=="all"){
            setData(Data);
            return;
        }
       const filteredData =  Data.filter((value)=>{
           return value.category == category;
       })
       setData(filteredData);
    }


  return (
    <>
      {/* <!-- Page Banner Section --> */}
      <section className="activity-section">
      <div className="auto-container">
      <div className="sec-title centered">
                        <div className="upper-icon"></div>
                        <h2>Our Gallery</h2>
                        {/* <!-- <div className="text">We believe what we achieve</div> --> */}
                    </div>
     
            {/* <!--End Banner Section --> */}
        <div className="container">
      <div className="row">
           
            <div className="col-ms-12">
            <Tabs filterCategory={filterCategory} tabsData={tabsData}/>
            <Items data={data} />
            </div>
           
        </div>
           
       </div>
       </div>
       </section>
    </>

  )
}

export default FacebookGallery
